export default "__VITE_ASSET__CYzz_aLF__"